<template>
<div class="row startDateEndDate StartDateSection">
    <div class="col">
        <otif-dateInput v-model="date" :validation="validation" :invalidMessage="invalidMessage" :datePickerOptions="datePickerOptions"></otif-dateInput>
    </div>
    <div class="col">
        <otif-select :values="hours" v-model="hour"></otif-select>
    </div>
    <div class="col">
        <otif-select :values="minutes" v-model="minute"></otif-select>
    </div>
    <div class="col">
        <otif-radio :values="['AM', 'PM']" v-model="meridiem" :name="formName + '-' + meridiem" :formName="formName" label="Time of Day"></otif-radio>
    </div>
</div>
</template>

<script>

import moment from 'moment';

export default {

    data() {
        return {
            _parsedDate: null,
            datePickerOptions: {
                format: 'YYYY-MM-DD',
                keepInvalid: true,
                //inline: true
            }
        };
    },

    computed: {

        hours() {
            return this.$lodash.range(1, 13).map((i) => {
                var l = i.toString();
                if (i < 10) {
                    l = '0' + l;
                }
                return {
                    value: i, // Compensates for bug in vue-select
                    label: l
                };
            });
        },
        minutes() {
            return this.$lodash.range(0,60).map((i) => {

                var l = i.toString();
                if (i < 10) {
                    l = '0' + l;
                }

                return {
                    value: i,
                    label: l
                };

            });
        },

        parsedDate: {
            cache: false,
            get() {
                if (!this.value) {
                    //return moment().hour(0).minute(0);
                } else {
                    return moment(this.value, 'YYYY-MM-DD[T]HH:mm:ssZZ');
                }
            }
        },

        date: {
            cache: false,
            get() {
                if (this.parsedDate) {
                    return this.parsedDate.format('YYYY-MM-DD');
                }
            },
            set(v) {
                this.eventDate({
                    date: v
                });
            }
        },

        hour: {
            get() {
                if (this.parsedDate) {
                    const hour = this.parsedDate.hour();

                    if (hour > 12) {
                        return (hour - 12).toString();
                    } else if (hour === 0) {
                        return (12).toString();
                    } else {
                        return hour.toString();
                    }
                }
            },
            set(v) {
                this.eventDate({
                    hour: parseInt(v)
                });
            }
        },

        minute: {
            get() {
                if (this.parsedDate) {
                    return this.parsedDate.minute().toString();
                }
            },
            set(v) {
                this.eventDate({
                    minute: parseInt(v)
                });
            }
        },
        meridiem: {
            cache: false,
            get() {
                if (this.parsedDate) {
                    const hour = this.parsedDate ? this.parsedDate.hour() : 0;

                    if (hour >= 12) {
                        return 'PM';
                    } else {
                        return 'AM';
                    }
                } else {
                    return 'AM';
                }
            },
            set(v) {
                this.eventDate({
                    meridiem: v
                });
            }

        }
    },

    props: ['value', 'formName', 'invalidMessage', 'validation'],

    methods: {
        eventDate(opts) {
            if (!opts) {
                opts = {};
            }

            var date = moment();

            var parts;


            if (opts && opts['date']) {
                parts = moment(opts['date'], "YYYY-MM-DD");
            } else {
                parts = moment(this.date, "YYYY-MM-DD");
            }

            date.year(parts.year());
            date.month(parts.month());
            date.date(parts.date());

            var meridiem = (opts['meridiem'])? opts['meridiem'] : this.meridiem;

            var hour = 0;
            var minute = 0;

            var h = opts['hour'] >= 0 ? opts['hour'] : parseInt(this.hour);

            if (meridiem === 'PM') {
                hour = h < 12 ? h + 12 : 12;
            } else {
                hour = h === 12 ? 0 : h;
            }

            date.hour(hour);

            if (opts.hasOwnProperty('minute')) {
                minute = parseInt(opts['minute']);
                date.minute(opts['minute']);
            } else {
                minute = this.minute;
            }

            date.minute(minute);
            date.seconds(0);

            this.$emit('input', date.format('YYYY-MM-DD[T]HH:mm:ssZZ'));
        }
    },

    watch: {
        value() {
            this._parsedDate = null;
        }
        /*
        date(newDate) {
            var parsed = moment(newDate, 'YYYY-MM-DD');

            if (this.meridiem === 'PM') {
                parsed.hour(this.hour + (this.hour < 12) ? this.hour : 0);
            } else {
                parsed.hour(this.hour);
            }

            parsed.minute(this.minute);
            parsed.second(0);

            this.$emit('input', parsed.toISOString());
        },

        hour(newHour) {

            var parsed = moment(this.date, 'YYYY-MM-DD');
            if (this.meridiem === 'PM') {
                parsed.hour(newHour + (newHour < 12) ? 12 : 0);
            } else {
                parsed.hour((newHour === 12) ? 0 : newHour);
            }

            parsed.minute(this.minute);
            parsed.second(0);

            this.$emit('input', parsed.toISOString());
        },

        minute(newMinute) {
            var parsed = moment(this.date, 'YYYY-MM-DD');
            if (this.meridiem === 'PM') {
                parsed.hour(this.hour + (this.hour < 12) ? 12: 0);
            } else {
                parsed.hour(this.hour);
            }

            parsed.minute(newMinute);
            parsed.second(0);

            this.$emit('input', parsed.toISOString());
        },

        meridiem(newMeridiem) {
            var parsed = moment(this.date, 'YYYY-MM-DD');
            if (newMeridiem === 'PM') {
                parsed.hour(this.hour + (this.hour < 12) ? 12 : 0);
            } else {
                parsed.hour(this.hour);
            }

            parsed.minute(this.minute);
            parsed.second(0);

            this.$emit('input', parsed.toISOString());
        }
        */
    }
}

</script>

